module.exports = __webpack_public_path__ + "img/covericon02.cf51dafd.png";